'use strict';
/**
 *  Module  柱形图数据服务
 *
 * Description
 */
angular.module('planHotHeadBarEchartsModule', []).factory('barEcharts', function() {
    return {
        /*
         *@params 数据对象
         *@success return 回调
         */
        barEcharts: function(params, success, id) {
            var initTopNewspaperName = [];
            var initTopNewspaperNumber = [];
            var initTopNewspaperGuid = [];
            var initTopNewspaperData = [];
            var initTopNewspaperSids = [];
            var initTopNewspaperIds = [];
            var initTopNewspaperFlag = [];
            var initTopNewspaperCid = [];
            for (var key in params) {
                initTopNewspaperName.push((params[key].SHORTTITLE||"").substr(0, 15));
                initTopNewspaperNumber.push(params[key].TOTALNUMBER);
                initTopNewspaperGuid.push(params[key].GUIDS);
                initTopNewspaperSids.push(params[key].HKEY);
                initTopNewspaperIds.push(params[key].CLUSTERID);
                initTopNewspaperFlag.push(params[key].PRODUCTFLAG);
                initTopNewspaperCid.push(params[key].GUID);
            }
            initTopNewspaperData = {
                name: initTopNewspaperName,
                data: initTopNewspaperNumber,
                guids: initTopNewspaperGuid,
                sids: initTopNewspaperSids,
                ids: initTopNewspaperIds,
                flag: initTopNewspaperFlag,
                guid: initTopNewspaperCid
            };
            return success(initTopNewspaperData);
        }
    };
});